import React from "react";

export default function About() {
  return (
    <section id="studio" data-testid="about-section" className="py-24 md:py-32 bg-[#FDFBF7]">
      <div className="container-ed grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <div className="overline mb-6">Lo Studio</div>
          <h2 className="serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0F172A]">
            Una collaborazione tra due <span className="italic text-[#A38A5A]">voci</span> del diritto.
          </h2>
        </div>
        <div className="lg:col-span-7 lg:pt-4">
          <p className="text-base md:text-lg leading-relaxed text-[#1C1917]">
            Lo Studio Legale Scotti &amp; Bava nasce dall'incontro professionale
            tra l'Avv. <span className="text-[#0F172A] font-medium">Giovanna Scotti</span>,
            con sede a Chieti (CH), e l'Avv. <span className="text-[#0F172A] font-medium">Salvatore Francesco Antonio Bava</span>,
            con sede a Bra (CN). Una rete professionale che coniuga la
            tradizione del foro abruzzese con l'esperienza del foro piemontese,
            attiva nelle principali aree del diritto: <span className="text-[#0F172A] font-medium">lavoro</span>,{" "}
            <span className="text-[#0F172A] font-medium">civile</span> (locazioni,
            contratti e recupero crediti) e{" "}
            <span className="text-[#0F172A] font-medium">penale</span>.
          </p>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-[#57534E]">
            Lo Studio assiste privati, lavoratori, dirigenti, professionisti e imprese
            in ogni fase del rapporto giuridico: dalla stesura del contratto alla gestione
            delle criticità, dalla conciliazione alla fase contenziosa, dinanzi al Tribunale
            ordinario, al Tribunale del Lavoro, al Giudice di Pace e nel processo penale.
          </p>
          <div className="mt-10 hairline pt-10 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {[
              { t: "Ascolto", d: "Ogni caso inizia con una lettura attenta delle circostanze umane e professionali." },
              { t: "Rigore", d: "Strategia processuale costruita su analisi giuridica approfondita e aggiornata." },
              { t: "Prossimità", d: "Due sedi, una sola interlocuzione: rapporto diretto con il professionista." },
            ].map((v) => (
              <div key={v.t}>
                <div className="serif text-2xl text-[#0F172A]">{v.t}</div>
                <p className="mt-3 text-sm leading-relaxed text-[#57534E]">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
